import getResponsiveAlternative, { getBestAlternativeName } from './getResponsiveAlternative';

export default function selectBestVideoSize(video, isSmall, width, height) {
  const alternative = getBestAlternativeName(video, isSmall);
  const { sizes } = getResponsiveAlternative(video, alternative);
  let index = sizes.findIndex(({ width: videoWidth, height: videoHeight }) => {
    let scale = width / videoWidth;
    let scaledHeight = videoHeight * scale;
    if (scaledHeight < height) {
      scaledHeight = height;
      scale = scaledHeight / videoHeight;
    }
    return scale < 1.2;
  });

  if (index < 0) {
    index = sizes.length - 1;
  }

  return { alternative, index };
}



// WEBPACK FOOTER //
// ./src/utils/selectBestVideoSize.js